import * as React from 'react';
import {useEffect, useRef, useState} from "react";
import Select, {components} from "react-select";
import SaveSearchModal from "../bo-core/modals/SaveSearchModal";
import {deleteSearch, saveSearch} from "../../actions/boCoreActions";
import toastr from "toastr";
import {useDispatch, useSelector} from "react-redux";
import AsyncPaginate from "react-select-async-paginate";
import Axios from "../../config/Axios";
import moment from "moment";
import {actions as savedSearchActions} from "../../actions/savedSearchActions";
import Utils from "../../Utils";

interface Props {
    currentDataView: any;
    lastSearch: any;

    handleSelectedSearch(searchObj: any): void;
}

export default function SavedSearchFields(props: Props) {
    const dispatch = useDispatch();
    const saveSearchModalRef = useRef(null);
    const user = useSelector((store: any) => store.auth.user);
    const selectedSavedSearch = useSelector((store: any) => store.savedSearchReducer.selectedSearch);
    const [asyncSelectKey, setAsyncSelectKey] = useState<string>('asyncSelectKey');

    useEffect(() => {
        document.addEventListener('keydown', keydownHandler);
        return () => {
            document.removeEventListener('keydown', keydownHandler);
        };
    }, [])

    const keydownHandler = (e) => {
        if (e.ctrlKey && e.altKey && e.keyCode === 83) {
            document.getElementById("saveSearchBtn").click();
        }
    }

    const onSearchSelected = (searchObj: any) => {
        props.handleSelectedSearch(searchObj)
    };

    const onSaveSearch = () => {
        document.getElementById("saveSearchBtn").blur();
        saveSearchModalRef.current.show();
    };

    const triggerLoadSearches = () => {
        // Workaround for triggering loadOptions callback by key update. Currently there is no other solution - jan. 2021
        setAsyncSelectKey(asyncSelectKey+moment());
    };

    const onSavedSearchDelete = (event, data) => {
        event.stopPropagation();
        deleteSearch(data.value)
            .then(() => {
                triggerLoadSearches();
                toastr.success("Search has been deleted successfully.")
                if (selectedSavedSearch && selectedSavedSearch.value === data.value) {
                    dispatch({type: savedSearchActions.SET_SELECTED_SEARCH, payload: null});
                }
            })
    };

    const SavedSearchOption = props => {
        const {Option} = components;
        return <Option {...props}>
            {props.data.label} <i className="fas fa-times" style={{float: "right", cursor: "pointer"}}
                                  onClick={(event) => onSavedSearchDelete(event, props.data)}/>
        </Option>;
    };

    const handleSaveSearch = (searchName: string) => {
        let dto = {
            dataViewId: props.currentDataView.id,
            name: searchName,
            search: props.lastSearch
        };
        saveSearch(dto)
            .then(() => {
                triggerLoadSearches();
                saveSearchModalRef.current.hide();
                toastr.success("Search has been saved successfully.")
            })
            .catch(() => {
                saveSearchModalRef.current.hide();
            })
    };

    const loadSearches = async (inputValue: string, loadedOptions: any) => {
        const size = 50;
        const page = Math.ceil(loadedOptions.length / size);
        try {
            const response = await Axios.instanceV2.get(`search/list?page=${page}&size=${size}&username=${user.username}&name=${inputValue}`)

            const dataArray = []
                .concat(response.data.data.map((item: any) => {
                    return {
                        value: item.id,
                        label: item.name,
                        data: item
                    }
                }))
                .filter(item => item.label.toLowerCase().includes(inputValue.toLowerCase()));

            return {
                options: dataArray,
                hasMore: !response.data.lastPage
            };
        } catch (e) {
            return {
                options: [],
                hasMore: false
            }
        }
    };

    const setGlobalSearchToFocus = (e) => {
        if (e.keyCode === 9) {
            e.preventDefault();
            document.getElementById('manage-data-search').focus();
        }
        if (e.ctrlKey && e.altKey) {
            e.preventDefault();
        }
    };

    return (
        <div style={{width: 320, display: "flex"}}>
            <div style={{width: 200}}>
                <AsyncPaginate
                    id={'savedSearchSelect'}
                    key={asyncSelectKey}
                    styles={Utils.getReactSelectNewDesign()}
                    menuPlacement={"bottom"}
                    SelectComponent={Select}
                    cacheOptions
                    defaultOptions
                    loadOptions={loadSearches}
                    onChange={onSearchSelected}
                    value={selectedSavedSearch}
                    placeholder={'Select Saved Search'}
                    components={{Option: SavedSearchOption}}
                    onKeyDown={setGlobalSearchToFocus}
                    tabIndex={3}
                    theme={theme => ({
                        ...theme,
                        colors: {
                            ...theme.colors,
                            primary25: '#5f8c90',
                            primary: '#34585b',
                            primary50: '#5f8c90'
                        },
                    })}
                />
            </div>
            <button
                id={'saveSearchBtn'}
                onClick={onSaveSearch}
                className={"btn btn-new-design"}
                title={'CTRL + ALT + S'}
                style={{marginLeft: 4}}
            >
                <i className="fas fa-save"/> <strong style={{fontSize: '14px'}} className={'shortcut-btn-letters'}>S</strong>ave Search
            </button>
            <SaveSearchModal
                ref={saveSearchModalRef}
                {...{handleSaveSearch: handleSaveSearch}}
            />
        </div>
    )
}



// WEBPACK FOOTER //
// ./app/components/common/SavedSearchFields.tsx